export default __webpack_public_path__ + "static/media/martin_quaker.ca2d6134.jpg";